(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("ReactCookieClicker", ["react"], factory);
	else if(typeof exports === 'object')
		exports["ReactCookieClicker"] = factory(require("react"));
	else
		root["ReactCookieClicker"] = factory(root["react"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__156__) {
return 